var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserFill = function SvgUserFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1 12.936c.368-.077.588-.463.405-.792-.404-.725-1.04-1.362-1.854-1.848C10.603 9.671 9.32 9.332 8 9.332s-2.605.339-3.653.964c-.814.486-1.45 1.123-1.853 1.848-.183.33.036.715.405.792 3.364.7 6.837.7 10.202 0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.001,
    cy: 5.333,
    r: 3.333
  })));
};
export default SvgUserFill;